
export default {
  props: ['curso', 'panel', 'loaded'],
  data() {
    return {
      modalPreco: false,
    }
  },
  computed: {
    preco: (v) =>
      v.curso?.investimento?.filter(
        (c) => c?.forma && c?.forma === 'cartão'
      )[0],
  },
}
